import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/contexts/AuthContext";
import { LogoIcon, LogoWordmark } from "@/components/Logo";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { googleLogin } = useAuth();
  const { t } = useTranslation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return; // one-time session exchange (StrictMode-safe)
    hasProcessed.current = true;
    const sid = new URLSearchParams((location.hash || "").replace(/^#/, "")).get("session_id");
    (async () => {
      const res = await googleLogin(sid);
      if (res.ok) {
        navigate("/app", { replace: true });
      } else {
        toast.error(t("auth_google_failed"));
        navigate("/login", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-slateink bf-grain flex flex-col items-center justify-center gap-5 px-6" data-testid="auth-callback">
      <div className="flex items-center gap-2">
        <LogoIcon size={36} />
        <LogoWordmark dark className="text-base" />
      </div>
      <div className="flex items-center gap-2 text-sm font-semibold text-slate-300" data-testid="auth-callback-status">
        <Loader2 className="h-5 w-5 animate-spin text-brand" /> {t("auth_signing_in")}
      </div>
    </div>
  );
}
